export const POST_JOB_BRIEFINGS_CONSENT_REQUEST = "POST_JOB_BRIEFINGS_CONSENT_REQUEST";
export const POST_JOB_BRIEFINGS_CONSENT_SUCCESS = "POST_JOB_BRIEFINGS_CONSENT_SUCCESS";
export const POST_JOB_BRIEFINGS_CONSENT_FAILURE = "POST_JOB_BRIEFINGS_CONSENT_FAILURE";
